var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerySeverePain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint0_radial_3250_47067)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint1_linear_3250_47067)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint2_radial_3250_47067)",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint3_radial_3250_47067)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint4_radial_3250_47067)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 37.4972C31.6666 37.4972 37.4972 29.6629 37.4972 19.9986C37.4972 10.3344 31.6666 2.5 19.9986 2.5C8.33054 2.5 2.5 10.3344 2.5 19.9986C2.5 29.6629 8.33054 37.4972 19.9986 37.4972Z",
    fill: "url(#paint5_radial_3250_47067)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5C14.7018 22.5 17.5 19.7018 17.5 16.25C17.5 12.7982 14.7018 10 11.25 10C7.79822 10 5 12.7982 5 16.25C5 19.7018 7.79822 22.5 11.25 22.5Z",
    fill: "url(#paint6_radial_3250_47067)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 22.5C27.4816 22.5 30 19.9816 30 16.875C30 13.7684 27.4816 11.25 24.375 11.25C21.2684 11.25 18.75 13.7684 18.75 16.875C18.75 19.9816 21.2684 22.5 24.375 22.5Z",
    fill: "url(#paint7_radial_3250_47067)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 20C16.2316 20 18.75 17.4816 18.75 14.375C18.75 11.2684 16.2316 8.75 13.125 8.75C10.0184 8.75 7.5 11.2684 7.5 14.375C7.5 17.4816 10.0184 20 13.125 20Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 20C29.9816 20 32.5 17.4816 32.5 14.375C32.5 11.2684 29.9816 8.75 26.875 8.75C23.7684 8.75 21.25 11.2684 21.25 14.375C21.25 17.4816 23.7684 20 26.875 20Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 18.75C15.8211 18.75 17.5 17.0711 17.5 15C17.5 12.9289 15.8211 11.25 13.75 11.25C11.6789 11.25 10 12.9289 10 15C10 17.0711 11.6789 18.75 13.75 18.75Z",
    fill: "url(#paint8_linear_3250_47067)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 18.75C28.3211 18.75 30 17.0711 30 15C30 12.9289 28.3211 11.25 26.25 11.25C24.1789 11.25 22.5 12.9289 22.5 15C22.5 17.0711 24.1789 18.75 26.25 18.75Z",
    fill: "url(#paint9_linear_3250_47067)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3796 26.3096C12.3796 26.3096 14.8796 23.8096 19.8796 23.8096C24.8796 23.8096 27.3796 26.3096 27.3796 26.3096",
    stroke: "url(#paint10_linear_3250_47067)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.875 12.5) rotate(94.5739) scale(31.3499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514303,
    stopColor: "#F28A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71368,
    stopColor: "#E37C32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888763,
    stopColor: "#E7912D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3250_47067",
    x1: 18.125,
    y1: 1.875,
    x2: 23.75,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA502D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 17.5) rotate(135) scale(51.2652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.75 13.75) rotate(52.125) scale(21.3782 16.7657)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514303,
    stopColor: "#FF7961",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 15.625) rotate(90) scale(22.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.88336,
    stopColor: "#F7980A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.875 18.75) rotate(43.9708) scale(73.8161)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1111 11.3889) rotate(135) scale(12.1779 6.3029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3250_47067",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.75 12.5) rotate(135) scale(10.1647 5.73811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3250_47067",
    x1: 27.6923,
    y1: 11.25,
    x2: 26.25,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3250_47067",
    x1: 27.6923,
    y1: 11.25,
    x2: 26.25,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3250_47067",
    x1: 19.8796,
    y1: 18.8096,
    x2: 19.8796,
    y2: 23.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F3C43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512756"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerySeverePain);
export default __webpack_public_path__ + "static/media/verySeverePain.251159f70301aa2439a5c45744954269.svg";
export { ForwardRef as ReactComponent };